import { render, staticRenderFns } from "./IconBuilding.vue?vue&type=template&id=b25703e0&scoped=true&"
import script from "./IconBuilding.vue?vue&type=script&lang=js&"
export * from "./IconBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25703e0",
  null
  
)

export default component.exports